import {z} from 'zod';

import {conditionsToRegex} from '../../utils/utils';

const isPasswordValid = (value: string): boolean =>
  Object.values(conditionsToRegex).every(re => re.test(value)) &&
  !/\s/.test(value);

export const userFormSchema = z
  .object({
    username: z.string().min(1, 'Benutzername muss gesetzt sein.'),
    password: z
      .string()
      .nullable()
      .optional()
      .refine(value => !value || isPasswordValid(value), {
        message: 'Passwort erfüllt nicht alle Anforderungen.',
      }),
    firstname: z.string().min(1, 'Vorname muss gesetzt sein.'),
    lastname: z.string().min(1, 'Nachname muss gesetzt sein.'),
    email: z.string().min(1, 'E-Mail muss gesetzt sein.'),
    telefon: z.string().optional().default(''),
    locked: z.boolean().default(false),
    usergroups: z
      .array(z.string())
      .min(1, 'Der User muss mindestens einer Benutzergruppe zugeordnet sein.'),
  })
  .partial({telefon: true, locked: true});

export type UserFormValues = z.infer<typeof userFormSchema>;

export const userCreateFormSchema = userFormSchema.extend({
  password: z.string().refine(isPasswordValid, {
    message: 'Passwort erfüllt nicht alle Anforderungen.',
  }),
});

export type UserCreateFormValues = z.infer<typeof userCreateFormSchema>;
